import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    categories: [],
    sub_categories: [],
};

export const categorySlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        setSubCategories: (state, action) => {
            state.sub_categories = action.payload;
        },
    },
});

export const { setCategories, setSubCategories } = categorySlice.actions;

export default categorySlice.reducer;
